var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-input',{staticClass:"input-class",attrs:{"defaultValue":_vm.defaultValue,"max-length":_vm.maxLength,"placeholder":_vm.placeholder},on:{"change":_vm.change},model:{value:(_vm.item[_vm.itemKey]),callback:function ($$v) {_vm.$set(_vm.item, _vm.itemKey, $$v)},expression:"item[itemKey]"}})
}
var staticRenderFns = []

export { render, staticRenderFns }